module.exports = __webpack_public_path__ + "9e69d5b629edd4b28bd74734e8f6097c.svg";